function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import cn from 'classnames';
import { AnimatePresence, motion } from 'framer-motion';
import map from 'lodash/map';
import isObject from 'lodash/isObject';
import Alert from 'components/Alert';
import { useAlerts, useSystemAlerts } from './hooks';
import { onAction } from './helpers';
const AlertsBus = ({ className, isGlobal = false, activeClinicMembership })=>{
    const dispatch = useDispatch();
    const { alerts, onCloseAlert } = useAlerts(isGlobal, activeClinicMembership);
    const { systemAlerts = [], onCloseSystemAlert } = useSystemAlerts(isGlobal);
    const allAlerts = [
        ...alerts,
        ...systemAlerts
    ];
    const [isCollapsed, setIsCollapsed] = useState(false);
    const onClose = (alert)=>{
        const { alertConfigurationId } = alert;
        if (alertConfigurationId) {
            if (onCloseSystemAlert) onCloseSystemAlert(alert);
        } else {
            onCloseAlert(alert);
        }
    };
    const onToggleCollapse = ()=>{
        setIsCollapsed(!isCollapsed);
    };
    return /*#__PURE__*/ _jsx(motion.div, {
        className: cn('alertsBus', className),
        initial: {
            height: 0
        },
        animate: {
            height: allAlerts.length ? 'auto' : 0
        },
        transition: {
            ease: 'easeIn',
            duration: allAlerts.length ? 0.1 : 0.3
        },
        style: {
            overflow: 'hidden'
        },
        children: /*#__PURE__*/ _jsx(AnimatePresence, {
            children: map(allAlerts, (alert, idx)=>/*#__PURE__*/ _jsx(motion.div, {
                    initial: {
                        opacity: 0,
                        marginTop: isCollapsed ? '-55px' : '-55px'
                    },
                    animate: {
                        opacity: 1,
                        marginTop: idx && isCollapsed ? '-52px' : 0
                    },
                    exit: {
                        opacity: 0,
                        marginTop: '-55px'
                    },
                    transition: {
                        ease: 'linear',
                        duration: 0.3
                    },
                    style: {
                        position: 'relative',
                        zIndex: allAlerts.length - idx
                    },
                    children: /*#__PURE__*/ _jsx(Alert, _object_spread_props(_object_spread({
                        idx: idx,
                        isCollapsed: isCollapsed
                    }, alert), {
                        actions: alert.actions && alert.actions.map((action)=>_object_spread_props(_object_spread({}, action), {
                                action: ()=>onAction(action.action, dispatch)
                            })),
                        onClose: ()=>onClose(alert),
                        onToggleCollapse: onToggleCollapse
                    }))
                }, `alert-${isObject(alert.message) ? alert.message.id : alert.message}-${alert.id}`))
        })
    });
};
export default AlertsBus;
